
<div style="width: 100%; max-width: 650px; height: 100%; min-height: min(600px, 90dvh); overflow-y: auto;" data-cy="ar-card-payment">
  
  @if (configurationError) {
    <div data-cy="ar-card-payment-error">{{this.configurationError}}</div>
  }
  <tdo-payment [paymentProcessorId]="paymentProcessorId" [patientID]="patientId" hostApplication="PMS"
    [transactionMode]="TDO_PAYMENT_TRANSACTION_MODE.Payment" data-cy="tdo-payment"
    [transactionIdentifier]="transactionIdentifier" [paymentAmount]="paymentAmount" style="height:90%;display:block;"
    [accountDescription]="accountDescription" (transactionCompleted)="onTransactionCompleted($event)"
    [paymentFrom]="payeeName" [savePaymentInfo]="savePaymentInfo" [valPayMode]="valPayMode" >
  </tdo-payment>
  <!--  FOOTER-->
  <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="ar-card-payment-footer">
    <div style="flex: 1; margin-right: 6px;" data-cy="ar-card-payment-footer-spacer"></div>
    <button data-cy="patient-payment-close-btn" (click)="close()" class="tdo-button tdo-close"
    style="margin-right: 10px;">Close</button>
  </div>
</div>